import type { ElevatorTypes } from './options'

export const ElevatorTypeMap = {
  verticalReciprocatingConveyor: 'Vertical Reciprocating Conveyor',
  directActingHydraulic: 'Direct Hydraulic Elevator',
  dumbwaiter: 'Dumbwaiter',
  electricGearred: 'Electric Geared Elevator',
  electricGearless: 'Electric Gearless Elevator',
  escalator: 'Escalator',
  inclinedElevatorLift: 'Inclined Elevator Lift',
  privateResidenceElevator: 'Private Residence Elevator',
  lula: 'LULA',
  movingWalk: 'Moving Walk',
  rackAndPinion: 'Rack and Pinion',
  ropedHydraulic: 'Roped Hydraulic Elevator',
  wheelchairLift: 'Wheelchair Lift',
  windTurbine: 'Wind Turbine Elevator',
  stageLift: 'Stage Lift',
  materialLift: 'Material Lift',
} satisfies Record<string, ElevatorTypes>
